<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> </template>

    <div class="container-fluid" style="text-align: left">
      <div class="row mt-3">
        <div class="col-sm-3">
          <admin-nav></admin-nav>
        </div>

        <div class="col-sm-9">
          <div class="d-flex flex-row align-items-start">
            <div class="row flex mr-3">
              <div class="col-12 mb-2 d-flex flex-row align-items-center">
                <i v-if="!filter" style="min-width: 15px" class="fas fa-search mx-2" />
                <i
                  v-if="filter"
                  style="min-width: 15px; padding-left: 2px; padding-top: 2px"
                  class="fas fa-times mx-2 clickable"
                  @click="filter = ''"
                />
                <input
                  class="form-control listing-search"
                  placeholder="Search student, teacher, section, or district name"
                  v-model="filter"
                />
              </div>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              style="float: right"
            ></b-pagination>
          </div>
          <b-table
            ref="table"
            :show-empty="true"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:cell(student_name)="data">
              {{ fs.displayName(data.item.student_name) }}
            </template>
            <template v-slot:cell(teacher_name)="data">
              {{ fs.displayName(data.item.teacher_name) }}
            </template>
            <template v-slot:cell(downloads)="data">
              <button
                v-if="view == 'student'"
                class="btn-si-orange dl-btn"
                @click="exportProfiles(data.item)"
              >
                Profiles
              </button>
              <button
                v-if="view == 'teacher'"
                class="btn-si-orange dl-btn"
                @click="exportProfilesTeacher(data.item)"
              >
                Profiles
              </button>
              <button
                v-if="view == 'master'"
                class="btn-si-orange dl-btn"
                :disabled="downloadingProfile"
                :style="downloadingProfile ? {cursor: 'wait'} : {}"
                @click="exportProfileMasterFile()"
              >
                Profiles
              </button>
              <button
                v-if="view == 'student'"
                class="btn-si-yellow dl-btn"
                @click="exportPitchFeedback(data.item)"
              >
                Pitch Feedback
              </button>
              <button
                v-if="view == 'teacher'"
                class="btn-si-yellow dl-btn"
                @click="exportPitchFeedbackTeacher(data.item)"
              >
                Pitch Feedback
              </button>
              <button
                v-if="view == 'master'"
                class="btn-si-yellow dl-btn"
                :disabled="downloadingPitch"
                :style="downloadingPitch ? {cursor: 'wait'} : {}"
                @click="exportPitchFeedbackMasterFile(data.item)"
              >
                Pitch Feedback
              </button>
              <button
                v-if="view == 'student'"
                class="btn-si-green dl-btn"
                @click="exportTVRs(data.item)"
              >
                TVRs
              </button>
              <button
                v-if="view == 'teacher'"
                class="btn-si-green dl-btn"
                @click="exportTVRsTeacher(data.item)"
              >
                TVRs
              </button>
              <button
                v-if="view == 'master'"
                class="btn-si-green dl-btn"
                :disabled="downloadingTVR"
                :style="downloadingTVR ? {cursor: 'wait'} : {}"
                @click="exportTVRMasterFile(data.item)"
              >
                TVRs
              </button>
              <button
                v-if="view == 'student'"
                class="btn-si-blue dl-btn"
                @click="exportCanvases(data.item)"
              >
                Canvases
              </button>
              <button
                v-if="view == 'teacher'"
                class="btn-si-blue dl-btn"
                @click="exportCanvasesTeacher(data.item)"
              >
                Canvases
              </button>
              <button
                v-if="view == 'master'"
                class="btn-si-blue dl-btn"
                :disabled="downloadingCanvas"
                :style="downloadingCanvas ? {cursor: 'wait'} : {}"
                @click="exportCanvasMasterFile(data.item)"
              >
                Canvases
              </button>
            </template>
            <template v-slot:cell(videos)="data">
              <div v-if="view == 'student'">
                <div v-for="pitch in studentPitches(data.item)" :key="pitch.id">
                  <button
                    v-if="pitch.assignment"
                    class="btn-si-yellow dl-btn"
                    style="float: left"
                    @click="$router.push(`/pitch/${pitch.id}`)"
                  >
                    {{ `${pitch.assignment.name} (${pitch.team.name})` }}
                  </button>
                </div>
              </div>
              <div v-if="view == 'teacher'">
                  <button
                    class="btn-si-yellow dl-btn"
                    style="float: left"
                    @click="$router.push(`/pitches/${data.item.section_id}`)"
                  >
                     View >
                  </button>
              </div>
            </template>
            <template v-slot:cell(prototypes)="data">
              <div v-if="view == 'student'">
                <div
                  v-for="prototype in studentPrototypes(data.item)"
                  :key="prototype.id"
                >
                  <button
                    v-if="prototype.assignment"
                    class="btn-si-orange dl-btn"
                    style="float: left; background-color: orange !important"
                    @click="$router.push(`/prototype/${prototype.id}`)"
                  >
                    {{
                      `${prototype.assignment.name} (${prototype.team.name})`
                    }}
                  </button>
                </div>
              </div>
              <div v-if="view == 'teacher'">
                  <button
                    class="btn-si-orange dl-btn"
                    style="float: left; background-color: orange !important"
                    @click="$router.push(`/prototypes/${data.item.section_id}`)"
                  >
                     View >
                  </button>
              </div>
            </template>
            <template v-slot:cell(canvases)="data">
              <div v-if="view == 'student'">
                <div
                  v-for="canvas in studentCanvases(data.item)"
                  :key="canvas.id"
                >
                  <button
                    v-if="canvas.assignment"
                    class="btn-si-blue dl-btn"
                    style="float: left"
                    @click="$router.push(`/canvas/${canvas.id}`)"
                  >
                    {{
                      `${canvas.assignment.name} (${canvas.team.name})`
                    }}
                  </button>
                </div>
              </div>
              <div v-if="view == 'teacher'">
                  <button
                    class="btn-si-blue dl-btn"
                    style="float: left"
                    @click="$router.push(`/canvases/${data.item.section_id}`)"
                  >
                     View >
                  </button>
              </div>
            </template>
            <template v-slot:cell(score)="data">
              <button
                v-if="!data.item.graded"
                class="btn-success"
                @click="editScore(data.item)"
              >
                Score
              </button>
              <!--
              <input
                v-if="editing[data.item.id]"
                type="number"
                min="0"
                max="100"
                v-model.number="data.item.score"
                style="width: 50px; margin-right: 10px"
              />
              <i
                v-if="editing[data.item.id]"
                class="fas fa-check btn-primary clickable"
                style="padding: 5px"
                @click="scoreSubmission(data.item)"
              /> -->
              <p v-if="data.item.graded" style="float: left">
                {{ data.item.score.total }}
              </p>
              <i
                v-if="data.item.graded"
                class="fas fa-edit btn-success clickable"
                style="padding: 5px; float: left; margin-left: 10px"
                @click="editScore(data.item)"
              />
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal id="scoreModal">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">
          Score Portfolio: {{ fs.displayName(editingSubmission.student_name) }}
        </h3>
      </template>
      <div v-if="editingSubmission">
        <div class="d-flex flex-row align-items-start">
          <input
            type="number"
            min="0"
            max="100"
            v-model.number="editingSubmission.score.profile"
            style="width: 50px; margin-right: 10px"
          />
          <label>Profile</label>
        </div>
        <div class="d-flex flex-row align-items-start">
          <input
            type="number"
            min="0"
            max="100"
            v-model.number="editingSubmission.score.pitch"
            style="width: 50px; margin-right: 10px"
          />
          <label>Pitch</label>
        </div>
        <div class="d-flex flex-row align-items-start">
          <input
            type="number"
            min="0"
            max="100"
            v-model.number="editingSubmission.score.tvr"
            style="width: 50px; margin-right: 10px"
          />
          <label>TVR</label>
        </div>
        <div class="d-flex flex-row align-items-start">
          <input
            type="number"
            min="0"
            max="100"
            v-model.number="editingSubmission.score.canvas"
            style="width: 50px; margin-right: 10px"
          />
          <label>Canvas</label>
        </div>
        <div class="d-flex flex-row align-items-start">
          <input
            type="number"
            min="0"
            max="100"
            v-model.number="editingSubmission.score.total"
            style="width: 50px; margin-right: 10px"
          />
          <label style="font-weight: bold">Total</label>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-primary"
          @click="scoreSubmission(editingSubmission)"
        >
          Done
        </button>
      </template>
    </b-modal>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";

import AdminService from "@/services/AdminService";
import ProfileService from "@/services/ProfileService";
import PitchService from "@/services/PitchService";
import CanvasService from "@/services/CanvasService";
import ProgramService from "@/services/ProgramService";
import AssignmentService from "@/services/AssignmentService";
import SectionService from "@/services/SectionService";
import TeamService from "@/services/TeamService";
import FileService from "@/services/FileService";

import Notie from "@/services/NotieService";
import BB from "bluebird";
import fs from "@/services/FormatService";
import _ from "lodash";

export default {
  name: "ScorePortfolios",
  props: ["user"],

  components: { MainPage, AdminNav },

  data() {
    var view = this.$route.query.view;
    var fields = [];
    if (view == "student") {
      fields = [
        { key: "student_name", label: "Student", sortable: true },
        { key: "district_name", label: "District", sortable: true },
        { key: "section_name", label: "Class", sortable: true },
        { key: "downloads", label: "Downloads" },
        { key: "videos", label: "Pitches" },
        { key: "prototypes", label: "Prototypes" },
        { key: "canvases", label: "Canvases" },
        { key: "score", label: "Score" },
      ];
    } else if (view == "teacher") {
      fields = [
        { key: "teacher_name", label: "Teacher", sortable: true },
        { key: "district_name", label: "District", sortable: true },
        { key: "section_name", label: "Class", sortable: true },
        { key: "downloads", label: "Downloads" },
        { key: "videos", label: "Pitches" },
        { key: "prototypes", label: "Prototypes" },
        { key: "canvases", label: "Canvases" },
      ];
    } else {
      fields = [{ key: "downloads", label: "Downloads" }];
    }

    return {
      fs: fs,
      service: AdminService,

      filter: "",
      currentPage: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      totalRows: 1,

      view: view,
      fields: fields,

      pitches: [],
      prototypes: [],
      canvases: [],
      editing: {},
      editingSubmission: null,
      downloadingProfile: false,
      downloadingPitch: false,
      downloadingTVR: false,
      downloadingCanvas: false,

      allSubmissions: null,
    };
  },

  created() {
    if (this.view == "master") {
      this.loadAll();
    }
  },

  methods: {
    editScore(submission) {
      this.editingSubmission = submission;
      this.$bvModal.show("scoreModal");
      this.$forceUpdate();
    },

    scoreSubmission(submission) {
      submission.graded = true;
      this.service
        .updateSubmission(submission)
        .then(() => {
          Notie.success("Submission Graded");
          this.$bvModal.hide("scoreModal");
          this.$forceUpdate();
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to grade submission", e);
        });
    },

    studentPitches(row) {
      return this.pitches.filter((p) => p.student_ids.includes(row.student_id));
    },

    classPitches(row) {
      return this.pitches.filter(
        (p) => _.intersection(p.student_ids, row.student_ids).length > 0
      );
    },

    studentPrototypes(row) {
      return this.prototypes.filter((p) =>
        p.student_ids.includes(row.student_id)
      );
    },

    classPrototypes(row) {
      return this.prototypes.filter(
        (p) => _.intersection(p.student_ids, row.student_ids).length > 0
      );
    },

    studentCanvases(row) {
      console.log("canvases", this.canvases)
      return this.canvases.filter((c) =>
        c.team.user_ids.includes(row.student_id)
      );
    },

    loadAll() {
      this.service.listSubmissions({}).then((resp) => {
        this.allSubmissions = resp.data.result;
      });
    },

    items() {
      var pageOpts;
      if (this.view == "student") {
        pageOpts = {
          filter: this.filter,
          page_size: this.perPage,
          current_page: this.currentPage,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc,
          skip: (this.currentPage - 1) * this.perPage,
        };
      } else {
        pageOpts = {
          filter: this.filter,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc,
        };
      }

      let timestamp = new Date().getTime();
      this.latest = timestamp;
      return new Promise((resolve, reject) => {
        this.service
          .listSubmissions(pageOpts)
          .then((resp) => {
            if (timestamp != this.latest) {
              console.log("NOT LATEST", timestamp, this.latest);
              return;
            }

            this.totalRows = resp.data.count;

            if (this.view == "teacher") {
              resolve(this.groupByTeacher(resp.data.result));
            } else if (this.view == "student") {
              resolve(resp.data.result);
            } else if (this.view == "master") {
              resolve([{}]);
            }

            this.loadData(resp.data.result);
            this.$forceUpdate();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    groupByTeacher(submissions) {
      var groups = [];
      _.each(submissions, (s) => {
        var existing = groups.filter((f) => {
          return (
            f.teacher_id == s.teacher_id &&
            f.section_id == s.section_id &&
            f.district_id == s.district_id
          );
        });
        if (existing.length == 0) {
          groups.push({
            teacher_id: s.teacher_id,
            section_id: s.section_id,
            district_id: s.district_id,
            teacher_name: s.teacher_name,
            section_name: s.section_name,
            district_name: s.district_name,
            student_ids: [s.student_id],
            student_names: [s.student_name],
          });
        } else {
          existing[0].student_ids.push(s.student_id);
          existing[0].student_names.push(s.student_name);
        }
      });

      this.totalRows = groups.length;

      return groups.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },

    loadData(submissions) {
      this.loadCanvases(submissions);
      this.loadPitches(submissions);
    },

    loadCanvases(submissions) {
      console.log("load canvases");
      this.canvases = [];
      _.each(submissions, (s) => {
        CanvasService.getStudentCanvases(s.student_id, s.section_id)
          .then((resp) => {
            _.each(resp.data, (canvas) => {
              BB.props({
                assignment: AssignmentService.getCanvasAssignment(
                  canvas.assignment_id
                ),
                team: TeamService.getTeam(canvas.team_id),
              })
                .then((r) => {
                  canvas.assignment = r.assignment.data;
                  canvas.team = r.team.data;
                  let existing = _.find(this.canvases, (c) => c.id == canvas.id);
                  if (!existing) {
                    this.canvases.push(canvas);
                  }
                })
                .catch((e) => {
                  console.log(e);
                });
            });
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },

    loadPitches(submissions) {
      _.each(submissions, (s) => {
        this.service
          .getStudentPitches(s.student_id, s.section_id)
          .then((r) => {
            _.each(r.data, (p) => {
              AssignmentService.getPitchAssignment(p.assignment_id)
                .then((resp) => {
                  if (resp.data.id) {
                    p.assignment = resp.data;
                    if (
                      this.pitches.filter((pitch) => pitch.id == p.id).length ==
                      0
                    ) {
                      this.pitches.push(p);
                    }
                  }
                  this.$forceUpdate();
                })
                .catch((e) => {
                  console.log(e);
                  this.$forceUpdate();
                });
              AssignmentService.getPrototypeAssignment(p.assignment_id)
                .then((resp) => {
                  if (resp.data.id) {
                    p.assignment = resp.data;
                    if (
                      this.prototypes.filter(
                        (prototype) => prototype.id == p.id
                      ).length == 0
                    ) {
                      this.prototypes.push(p);
                    }
                  }
                  this.$forceUpdate();
                })
                .catch((e) => {
                  console.log(e);
                  this.$forceUpdate();
                });

              TeamService.getTeam(p.team_id)
                .then((resp) => {
                  p.team = resp.data;
                })
                .catch((e) => {
                  console.log(e);
                  this.$forceUpdate();
                });
            });
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },

    exportPitchFeedback(submission) {
      PitchService.getUserFeedbacks(
        submission.student_id,
        submission.section_id
      ).then((r) => {
        var feedbacks = r.data;
        var calls = {};
        _.each(feedbacks, (feedback) => {
          calls[feedback.assignment_id] = AssignmentService.getPitchAssignment(
            feedback.assignment_id
          );
          calls[feedback.team_id] = TeamService.getTeam(feedback.team_id);
        });
        BB.props(calls).then((r) => {
          _.each(feedbacks, (feedback) => {
            feedback.assignment = r[feedback.assignment_id].data;
            feedback.user = { role: "STUDENT", name: submission.student_name };
            feedback.team = r[feedback.team_id].data;
          });
          feedbacks = feedbacks.filter((f) => f.assignment.name);

          ProgramService.getSectionProgram(submission.section_id)
            .then((resp) => {
              var categories = resp.data.pitch_config.rubric.categories;
              _.each(feedbacks, (f) => {
                _.each(f.response.responses, (r) => {
                  r.category = _.find(categories, {
                    id: r.category_id,
                  });
                });
              });

              FileService.exportPitchFeedback(
                feedbacks,
                { name: fs.displayName(submission.student_name) },
                resp.data.pitch_config.rubric.categories
              );
            })
            .catch((e) => {
              console.log(e);
              Notie.error("Failed to load program", e);
            });
        });
      });
    },

    exportPitchFeedbackTeacher(submission) {
      PitchService.getSectionFeedbacks(submission.section_id).then((r) => {
        var feedbacks = r.data.filter((f) =>
          submission.student_ids.includes(f.user_id)
        );
        var calls = {};
        _.each(feedbacks, (feedback) => {
          calls[feedback.assignment_id] = AssignmentService.getPitchAssignment(
            feedback.assignment_id
          );
          calls[feedback.team_id] = TeamService.getTeam(feedback.team_id);
          calls[feedback.section_id] = SectionService.getSectionPrefilled(feedback.section_id);
        });
        BB.props(calls).then((r) => {
          _.each(feedbacks, (feedback) => {
            feedback.assignment = r[feedback.assignment_id].data;
            feedback.user = {
              role: "STUDENT",
              name:
                submission.student_names[
                  submission.student_ids.indexOf(feedback.user_id)
                ],
            };
            feedback.team = r[feedback.team_id].data;
            feedback.section = r[feedback.section_id].data;
            feedback.district = {'name': submission.district_name};
          });
          feedbacks = feedbacks.filter((f) => f.assignment.name);

          ProgramService.getSectionProgram(submission.section_id)
            .then((resp) => {
              var categories = resp.data.pitch_config.rubric.categories;
              _.each(feedbacks, (f) => {
                _.each(f.response.responses, (r) => {
                  r.category = _.find(categories, {
                    id: r.category_id,
                  });
                });
              });

              FileService.exportPitchFeedbackMasterFile(
                feedbacks,
                submission.section_name,
                resp.data.pitch_config.rubric.categories,
                true
              );
            })
            .catch((e) => {
              console.log(e);
              Notie.error("Failed to load program", e);
            });
        });
      });
    },

    exportPitchFeedbackMasterFile() {
      if (this.downloadingPitch) {
        return
      }
      Notie.info("Downloading Pitch Feedback Master File...")
      this.downloadingPitch = true;
      var submittedDistricts = new Set();
      var submittedStudents = new Set();
      for (var s of this.allSubmissions) {
        submittedDistricts.add(s.district_id);
        submittedStudents.add(s.student_id);
      }
      submittedDistricts = Array.from(submittedDistricts);
      submittedStudents = Array.from(submittedStudents);

      var district_calls = {};
      _.each(submittedDistricts, (d) => {
        district_calls[d] = this.service.getPitchFeedbacksPrefilled(d);
      });

      BB.props(district_calls)
        .then((resp) => {
          var feedbacks = [];
          _.each(submittedDistricts, (d) => {
            feedbacks = feedbacks.concat(resp[d].data);
          });
          _.each(feedbacks, (f) => {
            f.submitted = submittedStudents.includes(f.user_id)
          })
          var calls = {};
          _.each(feedbacks, (feedback) => {
            calls[feedback.section_id] = SectionService.getSectionPrefilled(feedback.section_id);
          });
          BB.props(calls).then((r) => {
            _.each(feedbacks, (feedback) => {
              feedback.section = r[feedback.section_id].data;
            });

            feedbacks = feedbacks.filter((f) => f.assignment && f.assignment.name);

            this.service
              .listPrograms({})
              .then((resp) => {
                var programs = resp.data.result;
                _.each(programs, (program) => {
                  var categories = program.pitch_config.rubric.categories;
                  var program_feedbacks = feedbacks.filter(
                    (f) => f.section.program_id == program.id
                  );
                  _.each(program_feedbacks, (f) => {
                    _.each(f.response.responses, (r) => {
                      r.category = _.find(categories, {
                        id: r.category_id,
                      });
                    });
                  });

                  if (program_feedbacks.length > 0) {
                    FileService.exportPitchFeedbackMasterFile(
                      program_feedbacks,
                      "Master File " + program.name,
                      categories,
                      true,
                      true
                    );
                  }
                  this.downloadingPitch = false;
                });
              })
              .catch((e) => {
                this.downloadingPitch = false;
                console.log(e);
                Notie.error("Failed to load programs", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to export pitch feedback", e);
        });
    },

    exportProfiles(submission) {
      ProfileService.getUserProfiles(
        submission.section_id,
        submission.student_id
      )
        .then((r) => {
          var profiles = r.data;
          var calls = {};
          _.each(profiles, (profile) => {
            calls[
              profile.assignment_id
            ] = AssignmentService.getProfileAssignment(profile.assignment_id);
          });
          BB.props(calls).then((r) => {
            _.each(profiles, (profile) => {
              profile.assignment = r[profile.assignment_id].data;
            });
            profiles = profiles.filter((p) => p.assignment.name);

            ProgramService.getSectionProgram(submission.section_id)
              .then((resp) => {
                FileService.exportProfiles(
                  profiles,
                  resp.data.profile_config.questions,
                  fs.displayName(submission.student_name),
                  submission.section_name
                );
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to load program", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to export profiles", e);
        });
    },

    exportProfilesTeacher(submission) {
      ProfileService.getSectionProfiles(submission.section_id)
        .then((r) => {
          var profiles = r.data.filter((p) =>
            submission.student_ids.includes(p.user_id)
          );
          var calls = {};
          _.each(profiles, (profile) => {
            calls[
              profile.assignment_id
            ] = AssignmentService.getProfileAssignment(profile.assignment_id);
            calls[profile.section_id] = SectionService.getSectionPrefilled(profile.section_id);
          });
          BB.props(calls).then((r) => {
            _.each(profiles, (profile) => {
              profile.assignment = r[profile.assignment_id].data;
              profile.student_name = fs.displayName(
                submission.student_names[
                  submission.student_ids.indexOf(profile.user_id)
                ]
              );
              profile.section = r[profile.section_id].data;
              profile.district = {'name': submission.district_name};
            });
            profiles = profiles.filter((p) => p.assignment.name);

            ProgramService.getSectionProgram(submission.section_id)
              .then((resp) => {
                ProgramService.get;
                FileService.exportProfileMasterFile(
                  [
                    {
                      profiles: profiles,
                      questions: resp.data.profile_config.questions,
                    },
                  ],
                  submission.section_name
                );
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to load program", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to export profiles", e);
        });
    },

    exportProfileMasterFile() {
      if (this.downloadingProfile) {
        return
      }
      Notie.info("Downloading Profile Master File...")
      this.downloadingProfile = true;
      var submittedDistricts = new Set();
      var submittedStudents = new Set();
      for (var s of this.allSubmissions) {
        submittedDistricts.add(s.district_id);
        submittedStudents.add(s.student_id);
      }
      submittedDistricts = Array.from(submittedDistricts);
      submittedStudents = Array.from(submittedStudents);

      var district_calls = {};
      _.each(submittedDistricts, (d) => {
        district_calls[d] = this.service.getProfilesPrefilled(d);
      });

      BB.props(district_calls)
        .then((resp) => {
          var profiles = [];
          _.each(submittedDistricts, (d) => {
            profiles = profiles.concat(resp[d].data);
          })
          _.each(profiles, (p) => {
            p.submitted = submittedStudents.includes(p.user_id);
          })
          var calls = {};
          _.each(profiles, (profile) => {
            calls[profile.section_id] = SectionService.getSectionPrefilled(profile.section_id);
          });
          BB.props(calls).then((r) => {
            _.each(profiles, (profile) => {
              profile.section = r[profile.section_id].data;
            });
            profiles = profiles.filter((p) => p.assignment && p.assignment.name);

            var profile_data = [];

            this.service.listPrograms({}).then((resp) => {
              var programs = resp.data.result;

              for (var program of programs) {
                var program_profiles = profiles.filter(
                  (p) => p.section.program_id == program.id
                );
                profile_data.push({
                  profiles: program_profiles,
                  questions: program.profile_config.questions,
                });
              }
              FileService.exportProfileMasterFile(profile_data, "Master File", true);
              this.downloadingProfile = false;
            });
          });
        })
        .catch((e) => {
          this.downloadingProfile = false;
          console.log(e);
          Notie.error("Failed to export profiles");
        });
    },

    exportTVRs(submission) {
      this.service
        .getStudentTVRs(submission.student_id, submission.section_id)
        .then((r) => {
          var tvrs = r.data;
          var calls = {};
          _.each(tvrs, (tvr) => {
            calls[tvr.assignment_id] = AssignmentService.getTVRAssignment(
              tvr.assignment_id
            );
          });
          BB.props(calls).then((r) => {
            _.each(tvrs, (tvr) => {
              tvr.assignment = r[tvr.assignment_id].data;
            });
            tvrs = tvrs.filter((tvr) => tvr.assignment.name);

            ProgramService.getSectionProgram(submission.section_id)
              .then((resp) => {
                FileService.exportTVRFeedback(
                  tvrs,
                  { name: submission.section_name },
                  resp.data.tvr_config.rubric.categories,
                  true
                );
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to export TVRs", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to get TVRs", e);
        });
    },

    exportTVRsTeacher(submission) {
      this.service
        .getSectionTVRs(submission.section_id)
        .then((r) => {
          var tvrs = r.data.filter(
            (p) =>
              submission.student_ids.includes(p.recipient_id) ||
              submission.student_ids.includes(p.provider_id)
          );
          var calls = {};
          _.each(tvrs, (tvr) => {
            calls[tvr.assignment_id] = AssignmentService.getTVRAssignment(
              tvr.assignment_id
            );
            calls[tvr.section_id] = SectionService.getSectionPrefilled(tvr.section_id);
          });
          BB.props(calls).then((r) => {
            _.each(tvrs, (tvr) => {
              tvr.assignment = r[tvr.assignment_id].data;
              tvr.section = r[tvr.section_id].data;
              tvr.district= {'name': submission.district_name};
            });
            tvrs = tvrs.filter((tvr) => tvr.assignment.name);

            ProgramService.getSectionProgram(submission.section_id)
              .then((resp) => {
                FileService.exportTVRFeedbackMasterFile(
                  tvrs,
                  submission.section_name,
                  resp.data.tvr_config.rubric.categories,
                  true
                );
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to export TVRs", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to get TVRs", e);
        });
    },

    exportTVRMasterFile() {
      if (this.downloadingTVR) {
        return
      }
      Notie.info("Downloading TVR Master File...")
      this.downloadingTVR = true;
      var submittedDistricts = new Set();
      var submittedStudents = new Set();
      for (var s of this.allSubmissions) {
        submittedDistricts.add(s.district_id);
        submittedStudents.add(s.student_id);
      }
      submittedDistricts = Array.from(submittedDistricts);
      submittedStudents = Array.from(submittedStudents);

      var district_calls = {};
      _.each(submittedDistricts, (d) => {
        district_calls[d] = this.service.getTVRsPrefilled(d);
      });

      BB.props(district_calls)
        .then((resp) => {
          var feedbacks = [];
          _.each(submittedDistricts, (d) => {
            feedbacks = feedbacks.concat(resp[d].data);
          });
          _.each(feedbacks, (f) => {
            f.submitted =
              submittedStudents.includes(f.recipient_id) ||
              submittedStudents.includes(f.provider_id);
          });

          var calls = {};
          _.each(feedbacks, (feedback) => {
            calls[feedback.section_id] = SectionService.getSectionPrefilled(feedback.section_id);
          });
          BB.props(calls).then((r) => {
            _.each(feedbacks, (feedback) => {
              feedback.section = r[feedback.section_id].data;
            });

            feedbacks = feedbacks.filter((f) => f.assignment && f.assignment.name);

            this.service
              .listPrograms({})
              .then((resp) => {
                var programs = resp.data.result;
                _.each(programs, (program) => {
                  var categories = program.tvr_config.rubric.categories;
                  var program_feedbacks = feedbacks.filter(
                    (f) => f.section.program_id == program.id
                  );
                  _.each(program_feedbacks, (f) => {
                    _.each(f.response.responses, (r) => {
                      r.category = _.find(categories, {
                        id: r.category_id,
                      });
                    });
                  });

                  if (program_feedbacks.length > 0) {
                    FileService.exportTVRFeedbackMasterFile(
                      program_feedbacks,
                      "Master File " + program.name,
                      categories,
                      true,
                      true
                    );
                  }
                });
                this.downloadingTVR = false;
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to load programs", e);
              });
          });
        })
        .catch((e) => {
          this.downloadingTVR = false;
          console.log(e);
          Notie.error("Failed to export TVR feedback", e);
        });
    },

    exportCanvases(submission) {
      CanvasService.getStudentCanvases(
        submission.student_id,
        submission.section_id
      )
        .then((r) => {
          var canvases = r.data;
          var calls = {};
          _.each(canvases, (c) => {
            calls[c.assignment_id] = AssignmentService.getCanvasAssignment(
              c.assignment_id
            );
            calls[c.team_id] = TeamService.getTeam(c.team_id);
          });
          BB.props(calls).then((r) => {
            _.each(canvases, (c) => {
              c.assignment = r[c.assignment_id].data;
              c.team = r[c.team_id].data;
            });
            canvases = canvases.filter((c) => c.assignment.name);


            ProgramService.getSectionProgram(submission.section_id)
              .then((resp) => {
                FileService.exportCanvases(
                  canvases,
                  resp.data.canvas_config,
                  fs.displayName(submission.student_name)
                );
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to export Canvases", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to get Canvases", e);
        });
    },

    exportCanvasesTeacher(submission) {
      CanvasService.getSectionCanvases(submission.section_id)
        .then((r) => {
          var canvases = r.data;
          var calls = {};
          _.each(canvases, (c) => {
            calls[c.assignment_id] = AssignmentService.getCanvasAssignment(
              c.assignment_id
            );
            calls[c.team_id] = TeamService.getTeam(c.team_id);
            calls[c.section_id] = SectionService.getSectionPrefilled(c.section_id);
          });
          BB.props(calls).then((r) => {
            _.each(canvases, (c) => {
              c.assignment = r[c.assignment_id].data;
              c.team = r[c.team_id].data;
              c.section = r[c.section_id].data;
              c.district = {'name': submission.district_name};
            });
            canvases = canvases.filter((c) => {
              for (var studentID of c.team.user_ids) {
                if (submission.student_ids.includes(studentID)) {
                  return true;
                }
              }
              return false;
            });
            canvases = canvases.filter((c) => c.assignment.name);

            ProgramService.getSectionProgram(submission.section_id)
              .then((resp) => {
                FileService.exportCanvasMasterFile(
                  canvases,
                  resp.data.canvas_config,
                  fs.displayName(submission.section_name)
                );
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to export Canvases", e);
              });
          });
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to get Canvases", e);
        });
    },

    exportCanvasMasterFile() {
      if (this.downloadingCanvas) {
        return
      }
      Notie.info("Downloading Canvas Master File...")
      this.downloadingCanvas = true;
      var submittedDistricts = new Set();
      var submittedStudents = new Set();
      for (var s of this.allSubmissions) {
        submittedDistricts.add(s.district_id);
        submittedStudents.add(s.student_id);
      }
      submittedDistricts = Array.from(submittedDistricts);
      submittedStudents = Array.from(submittedStudents);

      var district_calls = {};
      _.each(submittedDistricts, (d) => {
        district_calls[d] = this.service.getCanvasesPrefilled(d);
      });

      BB.props(district_calls)
        .then((resp) => {
          var canvases = [];
          _.each(submittedDistricts, (d) => {
            canvases = canvases.concat(resp[d].data);
          });

          var calls = {};
          _.each(canvases, (c) => {
            calls[c.section_id] = SectionService.getSectionPrefilled(
              c.section_id
            );
          });
          BB.props(calls).then((r) => {
            _.each(canvases, (c) => {
              c.section = r[c.section_id].data;
            });
            canvases = canvases.filter(
              (c) => c.assignment && c.assignment.name
            );
            _.each(canvases, (c) => {
              c.submitted = false;
              for (var uid of c.team.user_ids) {
                if (submittedStudents.includes(uid)) {
                  c.submitted = true;
                }
              }
            })

            this.service
              .listPrograms({})
              .then((resp) => {
                var programs = resp.data.result;
                _.each(programs, (program) => {
                  var program_canvases = canvases.filter(
                    (c) => c.section.program_id == program.id
                  );
                  if (program_canvases.length > 0) {
                    FileService.exportCanvasMasterFile(
                      program_canvases,
                      program.canvas_config,
                      "Master File " + program.name,
                      true
                    );
                  }
                });
                this.downloadingCanvas = false;
              })
              .catch((e) => {
                console.log(e);
                Notie.error("Failed to export Canvases", e);
              });
          });
        })
        .catch((e) => {
          this.downloadingCanvas = false;
          console.log(e);
          Notie.error("Failed to get Canvases", e);
        });
    },
  },
};
</script>

<style scoped>
.dl-btn {
  border: 0px;
  font-size: 14px;
  margin: 2px;
}
</style>
